import { handleSubmit } from '../../components/ProgressiveFormStepper/utils';
import { formatOption } from '../../handlers/utils';
import { getResumeOrSectionIndex, onLink } from '../../handlers';
import { removeCheckedItem } from '../Checkboxes/utils';
import { compare } from '../ComputerSkills/utils';
import { runAxios } from '../../handlers/axios';
import { getUsefulVars } from '../../handlers/helpers';
import { setUcwords } from '../../formControllers/Transformation/Utils';


const addFlash =(alpha,div) => {
  if (alpha < 1) {
    alpha += .1;
    div.style.backgroundColor = 'rgba(255, 240, 0,' + alpha + ')';
    setTimeout(function() {
      addFlash(alpha, div)
    }, 100)
  } else {
    removeFlash(alpha,div);
  }
}
const removeFlash = (alpha,div) => {
  if (alpha > .1 ) {
    alpha -= .1;
    div.style.backgroundColor = 'rgba(255, 240, 0,' + alpha + ')';
    setTimeout(function() {
      removeFlash(alpha, div)
    }, 100)
  }
}

const fetchMoreSkillsCallback = (result,args) => {

  const qObj = args.qObj;
  const uv = getUsefulVars(args.props);
  const stateProps = uv.stateProps;

  //stateProps.setLoadingSkills(false);
  const skills = qObj.options;
 /* const existingSkills = stateProps.dataToSave.saved.resumes[stateProps.sectionData.resumeIndex]
  if(!stateProps.regenExpertise && typeof existingSkills['technical-skills'] !== 'undefined') {
    for (const skill of existingSkills['technical-skills'][0].TSQ5) {
      skills_raw.push(skill);
    }
  }*/
  const tsq5_checkboxes = document.querySelector('#TSQ5_checkboxes');
  let alpha = .1;
  addFlash(alpha,tsq5_checkboxes);
  for (const skill of result.data.expertise) {
    if(!skills.includes(skill)) {
      const skillObj = {
        key: skill,
        label: skill,
        value: skill,
      };
      skills.unshift(skillObj);
    }
  }
  //skills.sort( compare)
  uv.resume.expertiseData = {options:skills}
  stateProps.setSpinnerImage('default.gif');
  stateProps.setSpinnerMessage('');
  stateProps.onSpinnerClose();
}

/**
 *
 * @param props
 */
export const fetchMoreSkills = (props,qObj) => {
  const uv = getUsefulVars(props);

  const expertiseKeyword = document.querySelector('#expertiseKeywordSearch');
  const expertiseIndustry = document.querySelector('#expertiseIndustrySearch');
  const expertiseJobTitle = document.querySelector('#expertiseJobTitleSearch');
  const industry = expertiseIndustry !== null ? expertiseIndustry.value : uv.resume.industry[0];

const target_role = expertiseJobTitle !== null ? expertiseJobTitle.value : uv.resume.job_title;
  const keyword = expertiseKeyword.value;
  const past_job_titles = [];
  const pe = uv.resume['professional-experience'];
  if(pe !== undefined) {
    for(const work of pe) {
      if(work.job_title !== undefined) {
        past_job_titles.push(work.job_title);
      }
    }
  }
  const url = uv.stateProps.domain + '/wp-json/rsworks/v1/moreExpertise';
  const request = {
    'target_job_title':target_role,
    'target_industry':industry,
    'past_job_titles':past_job_titles,
    'keyword': keyword,
  };
  const args = {
    props:props,
    qObj:qObj,
    message:'Fetch More Skills',
  }
  uv.stateProps.setSpinnerMessage('Your skillset is vast! (Give us a second to put it all together.)');
  uv.stateProps.setSpinnerImage('expertiseSearch.gif');
  uv.stateProps.onSpinnerOpen();

  runAxios(url,request,fetchMoreSkillsCallback,args);
};

export const removeSelectedSkill= (props, qid, qValue) => {
  const uv = getUsefulVars(props);
  const index = getResumeOrSectionIndex(uv.stateProps,uv.formikProps);
  removeCheckedItem(props, index, qid, qValue);
  uv.stateProps.setCounter(uv.stateProps.counter+1);
}

/**
 *
 * @param props
 * @param qObj
 */
export const handleNewExpertiseCheckbox = (props, qObj) => {
  const addButton = document.querySelector('#addAnother_' + qObj.qid);
  const value = addButton.value;
  let add = value.trim().length > 0;
  if (qObj.options) {
    for (let i = 0; i < qObj.options.length; i++) {
      const optionLabel=qObj.options[i].label.trim().toLowerCase();
      const valueTest = value.trim().toLowerCase()
      if (optionLabel === valueTest) {
        add = false;
        break;
      }

    }
  }
  if (add) {
    const newCheckBoxValue = { label: value, key: value, value: value };
    qObj.options.push(newCheckBoxValue);
    let index = getResumeOrSectionIndex(props.stateProps, props.formikProps);
    if(index===-1) {
      index=0;
    }
    if (!props.formikProps.values.jobSeekerData[index][qObj.qid]) {
      props.formikProps.values.jobSeekerData[index][qObj.qid] = [];
    }
    props.formikProps.values.jobSeekerData[index][qObj.qid].push(value);
    let counter = props.stateProps.counter;
    props.stateProps.setCounter(counter + 1);
  } else {
    alert('Cannot add duplicate program');
  }
  addButton.value = '';
  props.stateProps.setCounter(props.stateProps.counter + 1);
}
/**
 *
 * @param props
 * @param e
 * @param qid
 * @param qValue
 * @param index
 */
export const handleExpertiseCheckbox = (props, e, qid, qValue, index) => {

  const isChecked = e.currentTarget.checked;
  const secPart = props.formikProps.values.jobSeekerData[index];
  secPart[qid] = typeof secPart[qid] !== 'undefined' ? secPart[qid] : [];
  if (isChecked) {
    props.formikProps.values.jobSeekerData[index][qid].push(qValue);
  } else {
    removeCheckedItem(props, index, qid, qValue);
  }
  handleSubmit(props,'technical-skills');
  props.stateProps.setCounter(props.stateProps.counter + 1);
};
/**
 *
 * @param industryOption
 * @returns {*}
 */
export const formatIndustryOption = (industryOption) => {
  return formatOption({ value: industryOption[0], label: industryOption[1].label });
}
/**
 *
 * @param formikProps
 * @param stateProps
 * @param uri
 * @param editableIndex
 * @param sectionType
 */
export const getSkills = (formikProps, stateProps, uri, editableIndex = 0, sectionType = 'section') => {
  onLink(false,formikProps, stateProps, uri, editableIndex = 0, sectionType = 'section')
  //getOptions(formikProps, stateProps, uri, editableIndex = 0, sectionType = 'section');
//
}
export const scrubSelected = (props,selectedSkills) => {
  const uv = getUsefulVars(props);
  const targetSkills = uv.resume.expertiseData !== undefined ? uv.resume.expertiseData.options : [];
  const scrubbedSkills= [];
  for (const tskill of targetSkills) {
    if (selectedSkills.includes(tskill.value)) {
      scrubbedSkills.push(tskill.value);
    }
  }
  return scrubbedSkills;
}
const getExpertiseCallback =(result,args) => {
  if (result.data === undefined || result.data.expertise === undefined) {
    alert('Something went wrong. Please try again.  If the problem persists contact support.');
  } else {
    const uv = getUsefulVars(args.props);

    const skills_raw = [];
    const existingSkills = uv.stateProps.dataToSave.saved.resumes[uv.stateProps.sectionData.resumeIndex]
    if (typeof existingSkills['technical-skills'] !== 'undefined') {
      for (const skill of existingSkills['technical-skills'][0].TSQ5) {
        skills_raw.push(skill);
      }
    }
    //add skills from ai
    for (const skill of result.data.expertise) {
      if (!skills_raw.includes(skill)) {
        skills_raw.push(skill);
      }
    }

  const skills = [];
  for(const skill_raw of skills_raw) {

    const skill = setUcwords(skill_raw);
    const skillObj = {
      key: skill,
      label:skill,
      value:skill,
    };

      skills.push(skillObj);
    }
    skills.sort(compare)
    uv.resume.regenExpertise = false;
    uv.resume.expertiseData = { options: skills };
    uv.stateProps.setSpinnerImage('default.gif');
    uv.stateProps.setSpinnerMessage('');
    uv.stateProps.onSpinnerClose();
  }
}
/**
 *
 * @param props
 * @param uri
 * @param editableIndex
 * @param sectionType
 */
export const getExpertise = (stateProps, uri, editableIndex = 0, sectionType = 'section') => {
  //regen if alreadyLoaded is false

  const url = stateProps.domain + '/wp-json/rsworks/v1/skills';
  const resumeIndex = stateProps.sectionData.resumeIndex;
  const job_title = stateProps.dataToSave.saved.resumes[resumeIndex].job_title;
  const past_job_titles = [];
  const pe = stateProps.dataToSave.saved.resumes[resumeIndex]['professional-experience'];
  if(pe !== undefined && pe !== null) {
    for(const work of pe) {
      if(work.job_title !== undefined) {
        past_job_titles.push(work.job_title);
      }
    }
  }
  const industry = stateProps.dataToSave.saved.resumes[resumeIndex].industry[0];
  const request = {
    'target_role':job_title,
    'industry':industry,
    'past_job_titles':past_job_titles
  };
  const args = {
    props:{stateProps},
    message:'Get Options',
  }
  stateProps.setSpinnerMessage('The journey to a satisfying career kicks off with a single step. \n'
  +'(And a functioning alarm clock)');
  stateProps.setSpinnerImage('expertise.gif');
  stateProps.onSpinnerOpen();
  //stateProps.setLoadingSkills(true);
  runAxios(url,request,getExpertiseCallback,args);
};